module.exports = __webpack_public_path__ + "static/footerCamBtn-d5cbf982f05c00ec2e39b5be35a6a292.svg";